<template>
    <div>
        <div class="offer-top pt-2 ">
            <svg class="ml-4 subentry_handle" width="14" height="12" viewBox="0 0 14 12" fill="none"
                xmlns="http://www.w3.org/2000/svg" style="cursor: all-scroll">
                <path d="M1 10.5H13M1 1.5H13H1ZM1 6H13H1Z" stroke="#CED0D5" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>

            <div class="subentry-box">
                <div class="inputs">
                    <div class="form-floating  name">
                        <input v-model="subentry.name" @keypress="SimilarSubEntries()" @blur="showSimilar = false"
                            type="text" class="form-control" id="floatingInput" placeholder="Názov položky">
                        <label for="floatingInput">Názov podpoložky</label>
                    </div>

                    <div class="top-inputs">
                        <div v-if="showSimilar" class="similar_entries">
                            <div v-if="SearchSubEntries.items.length > 0" class="database-items">
                                Databáza položiek
                            </div>
                            <div class="entry" v-for="en in SearchSubEntries.items" :key="en.id"
                                @mousedown="SetSimilar(en)">
                                <div class="left">
                                    <h6 class="name" v-if="en.nazov" v-html="matchName(en.nazov)"></h6>
                                    <span class="description" v-if="en.text"
                                        v-html="en.text.substring(0, 100) + (en.text.length > 100 ? '...' : '')"></span>
                                </div>
                                <div class="right">
                                    <span>{{ en.cena_polozka }} €</span>
                                </div>
                            </div>
                            <div v-if="SearchSubEntries.userEntries.length > 0" class="database-items">
                                História položiek
                            </div>
                            <div class="entry" v-for="en in SearchSubEntries.userEntries" :key="en.id"
                                @mousedown="SetSimilar(en)">
                                <div class="left">
                                    <h6 class="name" v-if="en.nazov_polozka" v-html="matchName(en.nazov_polozka)"></h6>
                                    <span class="description" v-if="en.text_polozka"
                                        v-html="en.text_polozka.substring(0, 100) + (en.text_polozka.length > 100 ? '...' : '')"></span>
                                </div>
                                <div class="right">
                                    <span>{{ en.cena_polozka }} €</span>
                                </div>
                            </div>
                        </div>
                        <div class="add-popis-mobile">
                            <div v-show="showText" class="form-floating txtarea">
                                <vue-editor v-model="subentry.text" :editorToolbar="customToolbar"></vue-editor>
                                <div class="textarea-icons">
                                    <svg @click="showText = false" class="trash m-0" width="20" height="21"
                                        viewBox="0 0 20 21" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M9 2.5C8.81434 2.5001 8.63237 2.55188 8.47447 2.64955C8.31658 2.74722 8.18899 2.88692 8.106 3.053L7.382 4.5H4C3.73478 4.5 3.48043 4.60536 3.29289 4.79289C3.10536 4.98043 3 5.23478 3 5.5C3 5.76522 3.10536 6.01957 3.29289 6.20711C3.48043 6.39464 3.73478 6.5 4 6.5V16.5C4 17.0304 4.21071 17.5391 4.58579 17.9142C4.96086 18.2893 5.46957 18.5 6 18.5H14C14.5304 18.5 15.0391 18.2893 15.4142 17.9142C15.7893 17.5391 16 17.0304 16 16.5V6.5C16.2652 6.5 16.5196 6.39464 16.7071 6.20711C16.8946 6.01957 17 5.76522 17 5.5C17 5.23478 16.8946 4.98043 16.7071 4.79289C16.5196 4.60536 16.2652 4.5 16 4.5H12.618L11.894 3.053C11.811 2.88692 11.6834 2.74722 11.5255 2.64955C11.3676 2.55188 11.1857 2.5001 11 2.5H9ZM7 8.5C7 8.23478 7.10536 7.98043 7.29289 7.79289C7.48043 7.60536 7.73478 7.5 8 7.5C8.26522 7.5 8.51957 7.60536 8.70711 7.79289C8.89464 7.98043 9 8.23478 9 8.5V14.5C9 14.7652 8.89464 15.0196 8.70711 15.2071C8.51957 15.3946 8.26522 15.5 8 15.5C7.73478 15.5 7.48043 15.3946 7.29289 15.2071C7.10536 15.0196 7 14.7652 7 14.5V8.5ZM12 7.5C11.7348 7.5 11.4804 7.60536 11.2929 7.79289C11.1054 7.98043 11 8.23478 11 8.5V14.5C11 14.7652 11.1054 15.0196 11.2929 15.2071C11.4804 15.3946 11.7348 15.5 12 15.5C12.2652 15.5 12.5196 15.3946 12.7071 15.2071C12.8946 15.0196 13 14.7652 13 14.5V8.5C13 8.23478 12.8946 7.98043 12.7071 7.79289C12.5196 7.60536 12.2652 7.5 12 7.5Z"
                                            fill-opacity="0.25" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <div class="select_box"
                            v-bind:class="{ 'cena_zero': typeCena == 0, 'cena_one': typeCena == 1, 'cena_two': typeCena == 2 }">
                            <v-select id="subentry_select" v-model="typeCena" :items="cenaItems"
                                @change="changeTypeCena" label="Cena" append-icon="fas fa-chevron-down"></v-select>
                        </div>
                        <div class="subentry-price-mobile">
                            <div v-show="subentry.type.price_from" class="form-floating  price">
                                <money v-bind="suffix.price" v-model.number="subentry.values.price_from" type="text"
                                    class="form-control" id="floatingInput" placeholder=""></money>
                                <label for="floatingInput">Cena od</label>
                            </div>
                            <div v-show="subentry.type.price_to" class="form-floating  price">
                                <money v-bind="suffix.price" v-model.number="subentry.values.price_to" type="text"
                                    class="form-control" id="floatingInput" placeholder=""></money>
                                <label for="floatingInput">Cena do</label>
                            </div>
                        </div>
                        <div v-show="(subentry.type.price_from || subentry.type.price_to)" class="inline-subentries">
                            <div  class="form-floating  price" style="flex: 1;">
                                <money v-bind="suffix.price" v-model.number="subentry.values.price_from" type="text"
                                    class="form-control" id="floatingInput" placeholder=""></money>
                                <label for="floatingInput">Cena od</label>
                            </div>
                            <div class="form-floating  price" style="flex: 1;">
                                <money v-bind="suffix.price" v-model.number="subentry.values.price_to" type="text"
                                    class="form-control" id="floatingInput" placeholder=""></money>
                                <label for="floatingInput">Cena do</label>
                            </div>
                        </div>
                        <div v-show="subentry.type.id == 2" class="combobox" data-app>
                            <v-combobox  v-model="subentry.unit" label="Jednotka"
                                :items="unitItems" filled>
                            </v-combobox>
                        </div>
                        <div v-show="subentry.type.id != 1" class="inline-subentries">
                            <div v-show="subentry.type.number_of"
                                :class="'form-floating price-for-hours InputPocetSub ' + this.id + 'InputPocetSub'">
                                <v-text-field :label="subentry.type.id == 4 ? 'počet od' : 'počet'"
                                    v-model="subentry.values.number_of" @input="handleInput('number_of', 'InputPocetSub')"
                                    @blur="handleBlur('number_of', 'InputPocetSub')"
                                    :suffix="(suffix.number_of.suffix).toUpperCase()"></v-text-field>
                                <div class="stepper">
                                    <span @click="stepper(1, 1)">
                                        +
                                    </span>
                                    <span @click="stepper(1, 0)">
                                        -
                                    </span>
                                </div>
                            </div>
                            <div v-show="subentry.type.number_of_to"
                                :class="'form-floating price-for-hours InputPocetSub ' + this.id + 'InputPocetSubTo'">
                                <v-text-field label="počet do" v-model="subentry.values.number_of_to"
                                    @input="handleInput('number_of_to', 'InputPocetSubTo')" @blur="handleBlur('number_of_to', 'InputPocetSubTo')"
                                    :suffix="(suffix.number_of_to.suffix).toUpperCase()"></v-text-field>
                                <div class="stepper">
                                    <span @click="stepper(4, 1)">
                                        +
                                    </span>
                                    <span @click="stepper(4, 0)">
                                        -
                                    </span>
                                </div>
                            </div>
                            <div v-show="subentry.type.tariff"
                                :class="'form-floating price-for-hours InputSadzbaSub ' + this.id + 'InputSadzbaSub'">
                                <v-text-field label="sadzba" v-model="subentry.values.tariff" @input="handleInput('tariff', 'InputSadzbaSub')"
                                    @blur="handleBlur('tariff', 'InputSadzbaSub')" :suffix="suffix.tariff.suffix"></v-text-field>
                                <div class="stepper">
                                    <span @click="stepper(2, 1)">
                                        +
                                    </span>
                                    <span @click="stepper(2, 0)">
                                        -
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="form-floating price-for-hours dph_input" style="width: min-content;">
                            <input style="text-transform: none" type="text" class="form-control" id="floatingInput"
                                v-model="subentry.dph" @blur="calcDph" placeholder="DPH %" />
                            <label for="floatingInput">DPH %</label>
                        </div>
                        <div class="summary-last">
                            <div v-if="subentry.type.id == 1 || subentry.type.id == 4" class="sum form-floating">
                                <input
                                    :value="rangePriceWithoutDph().from.toFixed(2).toString() + ' - ' + rangePriceWithoutDph().to.toFixed(2).toString() + ' ' + currentCurrency"
                                    type="text" class="form-control" id="floatingInput" placeholder="" disabled />
                                <label v-if="dph() > 0" for="floatingInput">Cena od - do bez DPH</label>
                                <label v-else for="floatingInput">Cena od - do</label>
                            </div>
                            <div v-else-if="!subentry.type.price" class="sum form-floating">
                                <input :value="autoPriceWithoutDph().toFixed(2).toString() + ' ' + currentCurrency" type="text"
                                    class="form-control" id="floatingInput" placeholder="" disabled />
                                <label v-if="dph() > 0" for="floatingInput">Cena bez DPH</label>
                                <label v-else for="floatingInput">Cena</label>
                            </div>
                            <div v-else-if="subentry.type.price" class="sum form-floating">
                                <input :value="ownPriceWithoutDph().toFixed(2).toString() + ' ' + currentCurrency" type="text"
                                    class="form-control" @blur="changeOwnPrice($event.target.value)" id="floatingInput"
                                    placeholder="" />
                                <label v-if="dph() > 0" for="floatingInput">Vlastná cena bez DPH</label>
                                <label v-else for="floatingInput">Vlastná cena</label>
                            </div>
                        </div>
                    </div>
                    <div class="add-popis">
                        <div v-show="showText" class="form-floating txtarea">
                            <vue-editor v-model="subentry.text" :editorToolbar="customToolbar"></vue-editor>
                            <div class="textarea-icons">
                                <svg @click="showText = false" class="trash m-0" width="20" height="21"
                                    viewBox="0 0 20 21" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M9 2.5C8.81434 2.5001 8.63237 2.55188 8.47447 2.64955C8.31658 2.74722 8.18899 2.88692 8.106 3.053L7.382 4.5H4C3.73478 4.5 3.48043 4.60536 3.29289 4.79289C3.10536 4.98043 3 5.23478 3 5.5C3 5.76522 3.10536 6.01957 3.29289 6.20711C3.48043 6.39464 3.73478 6.5 4 6.5V16.5C4 17.0304 4.21071 17.5391 4.58579 17.9142C4.96086 18.2893 5.46957 18.5 6 18.5H14C14.5304 18.5 15.0391 18.2893 15.4142 17.9142C15.7893 17.5391 16 17.0304 16 16.5V6.5C16.2652 6.5 16.5196 6.39464 16.7071 6.20711C16.8946 6.01957 17 5.76522 17 5.5C17 5.23478 16.8946 4.98043 16.7071 4.79289C16.5196 4.60536 16.2652 4.5 16 4.5H12.618L11.894 3.053C11.811 2.88692 11.6834 2.74722 11.5255 2.64955C11.3676 2.55188 11.1857 2.5001 11 2.5H9ZM7 8.5C7 8.23478 7.10536 7.98043 7.29289 7.79289C7.48043 7.60536 7.73478 7.5 8 7.5C8.26522 7.5 8.51957 7.60536 8.70711 7.79289C8.89464 7.98043 9 8.23478 9 8.5V14.5C9 14.7652 8.89464 15.0196 8.70711 15.2071C8.51957 15.3946 8.26522 15.5 8 15.5C7.73478 15.5 7.48043 15.3946 7.29289 15.2071C7.10536 15.0196 7 14.7652 7 14.5V8.5ZM12 7.5C11.7348 7.5 11.4804 7.60536 11.2929 7.79289C11.1054 7.98043 11 8.23478 11 8.5V14.5C11 14.7652 11.1054 15.0196 11.2929 15.2071C11.4804 15.3946 11.7348 15.5 12 15.5C12.2652 15.5 12.5196 15.3946 12.7071 15.2071C12.8946 15.0196 13 14.7652 13 14.5V8.5C13 8.23478 12.8946 7.98043 12.7071 7.79289C12.5196 7.60536 12.2652 7.5 12 7.5Z"
                                        fill-opacity="0.25" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="summary">
                </div>
            </div>

            <div class="subentry_right">
                <div class="icons">
                    <svg @click="$emit('remove', id)" class="trash m-0" width="15" height="16" viewBox="0 0 15 16"
                        fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 4H2.33333H13" stroke="#9598A7" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M4.33301 3.99992V2.66659C4.33301 2.31296 4.47348 1.97382 4.72353 1.72378C4.97358 1.47373 5.31272 1.33325 5.66634 1.33325H8.33301C8.68663 1.33325 9.02577 1.47373 9.27582 1.72378C9.52587 1.97382 9.66634 2.31296 9.66634 2.66659V3.99992M11.6663 3.99992V13.3333C11.6663 13.6869 11.5259 14.026 11.2758 14.2761C11.0258 14.5261 10.6866 14.6666 10.333 14.6666H3.66634C3.31272 14.6666 2.97358 14.5261 2.72353 14.2761C2.47348 14.026 2.33301 13.6869 2.33301 13.3333V3.99992H11.6663Z"
                            stroke="#9598A7" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M5.66699 7.33325V11.3333" stroke="#9598A7" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M8.33301 7.33325V11.3333" stroke="#9598A7" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="disable_price">
                    <div class="icons">
                        <div class="info">
                            <div class="my_tooltip entry_tooltip">
                                <span>{{ !subentry.exclude ? 'Nezapočítať' : 'Započítať' }} podpoložku do celkovej ceny
                                    ponuky</span>
                                <div class="line"></div>
                                Táto podpoložka {{ !subentry.exclude ? 'nebude ' : 'bude ' }} započítaná do celkovej ceny tvojej ponuky.
                            </div>
                            <div class="tooltip_hover info_icon" :class="{ 'active': subentry.exclude }" @click="subentry.exclude = !subentry.exclude">
                                <svg fill="#9598A7" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM8 19.004h1.994C11.097 23 13.733 25 17.9 25c1.585 0 2.951-.216 4.1-.648v-2.373c-1.209.494-2.32.74-3.334.74-1.419 0-2.512-.271-3.277-.815-.766-.545-1.416-1.511-1.949-2.9h4.956l.8-2.003h-6.184c-.03-.378-.045-.806-.045-1.285 0-.416.019-.748.056-.995h7.096l.811-2.003h-7.422c.713-2.292 2.316-3.438 4.809-3.438a8.92 8.92 0 013.683.776V7.532A14.002 14.002 0 0018.103 7c-4.16 0-6.833 1.906-8.02 5.718H8.812L8 14.721h1.69a12.95 12.95 0 00-.057 1.25c0 .332.011.675.034 1.03H8.81z"
                                        fill-rule="evenodd"></path>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4 popeditor-trigger-holder">
            <span v-show="!showText" @click="showText = true" class="popisNone">Pridať popis položky</span>
        </div>
    </div>
</template>

<script>
import { Money } from 'v-money'
import { VueEditor } from "vue2-editor";
import { EventBus } from './EventBus';

export default {
    components: { Money, VueEditor },
    props: [
        'id',
        'newData',
        'getTariff',
        'newTariff',
        'units',
        'uuidOffer',
        'default_dph',
    ],
    data() {
        return {
            userSubEntries: [],
            ItemsAndPrices: [],
            customToolbar: [
                ["bold", "italic", "underline", "link"],
                [{ list: "ordered" }, { list: "bullet" }],
            ],
            subentry: {
                name: "",
                text: "",
                unit: "",
                type: {},
                values: {},
                exclude: false,
                dph: 0,
                price: 0,
                price_to: null,
                price_discount: 0,
                price_to_discount: null
            },
            cenaItems: [
                {
                    text: "Cena za hodinovú sadzbu",
                    value: 0
                }, {
                    text: "Hodinový rozsah od -do",
                    value: 4
                }, {
                    text: "Cenový rozsah od - do",
                    value: 1
                }, {
                    text: "Vlastná cena",
                    value: 2
                }
            ],
            unitItems: [
                "ks",
                "m2",
                "hod",
                "bm",
                "kpl",
                "m",
                "km",
                "NS",
                "MD",
                "MH",
            ],
            typeCena: 0,
            isOwnPrice: false,
            showText: false,
            showSimilar: false,
            suffix: {},
            types: [
                {
                    id: 0,
                    number_of: true,
                    number_of_text: "hodín",
                    number_of_to: false,
                    number_of_to_text: "",
                    tariff: true,
                    tariff_text: "/ hod",
                    price_from: false,
                    price_to: false,
                    price: false,
                    discount: true
                },
                {
                    id: 1,
                    number_of: false,
                    number_of_text: "",
                    number_of_to: false,
                    number_of_to_text: "",
                    tariff: false,
                    tariff_text: "",
                    price_from: true,
                    price_to: true,
                    price: false,
                    discount: true
                },
                {
                    id: 2,
                    number_of: true,
                    number_of_text: "",
                    number_of_to: false,
                    number_of_to_text: "",
                    tariff: true,
                    tariff_text: "",
                    price_from: false,
                    price_to: false,
                    price: true,
                    discount: true
                },
                {
                    id: 3,
                    number_of: false,
                    number_of_text: "",
                    number_of_to: false,
                    number_of_to_text: "",
                    tariff: false,
                    tariff_text: "",
                    price_from: false,
                    price_to: false,
                    price: false,
                    discount: false
                },
                {
                    id: 4,
                    number_of: true,
                    number_of_text: "hodín",
                    number_of_to: true,
                    number_of_to_text: "hodín",
                    tariff: true,
                    tariff_text: "/ hod",
                    price_from: false,
                    price_to: false,
                    price: false,
                    discount: true
                }
            ],
            currentCurrency: "€",            
            dph: function () {
                if (this.subentry.dph == null || this.subentry.dph == undefined || this.subentry.dph == "") {
                    return 0;
                } else {
                    if (isNaN(parseFloat(this.subentry.dph))) {
                        return 0;
                    }
                    return parseFloat(this.subentry.dph);
                }
            },
            ownPriceWithoutDph: function () {
                return parseFloat(this.subentry.values.own_price);
            },
            ownPriceWithDph: function () {
                return parseFloat(this.subentry.values.own_price) * (1 + this.dph() / 100);
            },
            ownPrice: function () {
                return this.ownPriceWithDph();
            },
            autoPriceWithoutDph: function () {
                return parseFloat(this.subentry.values.auto_price);
            },
            autoPriceWithDph: function () {
                return parseFloat(this.subentry.values.auto_price) * (1 + this.dph() / 100);
            },
            autoPrice: function () {
                return this.autoPriceWithDph();
            },

            rangePriceWithoutDph: function () {
                let from = parseFloat(this.subentry.values.price_from);
                let to = parseFloat(this.subentry.values.price_to);
                return {from: from, to: to};
            },
            rangePriceWithDph: function () {
                let from = parseFloat(this.subentry.values.price_from) * (1 + this.dph() / 100);
                let to = parseFloat(this.subentry.values.price_to) * (1 + this.dph() / 100);
                return { from, to };
            },
            rangePrice: function () {
                let from = this.rangePriceWithDph().from;
                let to = this.rangePriceWithDph().to;
                return { from, to };
            },
        }
    },
    created() {
        this.suffix =  {
            price: {
                thousands: ' ',
                suffix: ' ' + this.currentCurrency,
                precision: 2
            },
            discount: {
                suffix: '%',
                precision: 0
            },
            number_of: {
                suffix: ' hod',
                precision: 0
            },
            number_of_to: {
                suffix: ' hod',
                precision: 0
            },
            tariff: {
                thousands: '.',
                suffix: ' '+this.currentCurrency+' /hod',
                precision: 1
            }
        }
        this.subentry.type = this.types[0]
        this.subentry.values = {
            number_of: 0,
            number_of_to: 0,
            tariff: 0,
            price_from: 0,
            price_to: 0,
            auto_price: 0,
            own_price: 0,
            from_to_price: 0,
            discount: 0
        }
        if (Object.keys(this.newData).length != 0) {
            this.subentry = this.newData
            this.subentry.type = this.newData.type
            this.typeCena = this.subentry.type.id
            if (this.newData.isOwnPrice)
                this.isOwnPrice = this.newData.isOwnPrice
            if (this.subentry.text)
                this.showText = true

            this.subentry['price'] = 0,
                this.subentry['price_to'] = null,
                this.subentry['price_discount'] = 0,
                this.subentry['price_to_discount'] = null
            this.sendData()
        }
    },
    methods: {
        changeOwnPrice: _.debounce(function (value) {
            this.isOwnPrice = true
            if (value == null ||
                value == undefined ||
                value == "" ||
                isNaN(parseFloat(value))) {
                this.subentry.values.own_price = 0;
            } else {
                this.subentry.values.own_price = parseFloat(value.replace(',', '.'));
            }
        }, 100),
        calcDph: _.debounce(function () {
            if (isNaN(parseFloat(this.subentry.dph))) {
                this.subentry.dph = "";
            }
        }, 100),
        updateSuffix() {
            this.suffix.price.suffix = ' ' + this.currentCurrency
            this.suffix.tariff.suffix = ' '+this.currentCurrency+' /' + this.subentry.unit
        },
        changeTypeCena() {
            if (this.typeCena == 2 && this.subentry.unit == "hod")
                this.subentry.unit = ""
        },
        matchName(current) {
            var dots = ""
            if (current.length > 35) {
                current = current.substr(0, 35)
                dots = "..."
            }
            if (!this.subentry.name) return current;
            let reggie = new RegExp(this.subentry.name, "ig");
            let found = current.search(reggie) !== -1;
            return !found ? current : current.replace(reggie, '<b>' + this.subentry.name + '</b>') + dots;
        },
        SetSimilar(sim_subentry) {
            if (sim_subentry.label) {
                this.subentry.name = sim_subentry.verejny_nazov == null ? sim_subentry.nazov : sim_subentry.verejny_nazov
                this.subentry.text = sim_subentry.text
                this.subentry.unit = sim_subentry.jednotka
                this.subentry.exclude = true
                if (sim_subentry.nezobrazovat_cena == 0)
                    this.subentry.exclude = false

                this.typeCena = parseInt(sim_subentry.type_cena)
                this.subentry.type = this.types[sim_subentry.type_cena]
                if (this.typeCena == 2) {
                    this.subentry.unit = sim_subentry.jednotka
                    if (sim_subentry.jednotka == "new")
                        this.subentry.unit = "hod"
                    if (sim_subentry.jednotka == null)
                        this.subentry.unit = ""
                    this.isOwnPrice = true
                }
                this.subentry.values = {
                    number_of: parseFloat(sim_subentry.pocet_hodin),
                    number_of_to: parseFloat(sim_subentry.pocet_hodin_do),
                    tariff: parseFloat(sim_subentry.hodinova_sadzba),
                    price_from: parseFloat(sim_subentry.cena),
                    price_to: parseFloat(sim_subentry.cena_do),
                    auto_price: parseFloat(sim_subentry.pocet_hodin) * parseFloat(sim_subentry.hodinova_sadzba),
                    own_price: parseFloat(sim_subentry.cena),
                    discount: 0
                }
            } else {
                this.subentry.name = sim_subentry.nazov_polozka
                this.subentry.text = sim_subentry.text_polozka
                this.subentry.exclude = true
                if (sim_subentry.nezobrazovat_cena_polozka == 0)
                    this.subentry.exclude = false
                this.typeCena = parseInt(sim_subentry.type_cena_polozka)
                this.subentry.type = this.types[sim_subentry.type_cena_polozka]
                if (this.typeCena == 2) {
                    this.subentry.unit = sim_subentry.jednotka_polozka
                    if (sim_subentry.jednotka_polozka == "new")
                        this.subentry.unit = "hod"
                    if (sim_subentry.jednotka_polozka == null)
                        this.subentry.unit = ""
                    this.isOwnPrice = true
                }
                this.subentry.values = {
                    number_of: parseFloat(sim_subentry.hodiny_polozka),
                    number_of_to: parseFloat(sim_subentry.hodiny_polozka_do),
                    tariff: parseFloat(sim_subentry.sadzba_polozka),
                    price_from: parseFloat(sim_subentry.cena_polozka),
                    price_to: parseFloat(sim_subentry.cena_do_polozka),
                    auto_price: parseFloat(sim_subentry.hodiny_polozka) * parseFloat(sim_subentry.sadzba_polozka),
                    own_price: parseFloat(sim_subentry.cena_polozka),
                    discount: 0
                }
            }

            this.showDiscount = false
            this.showText = false
            if (this.subentry.text)
                this.showText = true
            this.sendData()
            this.showSimilar = false
        },
        SimilarSubEntries() {
            if (this.subentry && this.subentry.name && this.subentry.name.length > 1) {
                if (this.SearchSubEntries)
                    if (this.SearchSubEntries.length == 0)
                        this.showSimilar = false
            }
        },
        //------subentry functions------------------
        handleInput(field, cssClass) {
            const value = this.subentry.values[field];
            let length = value ? value.toString().length : 0;

            let width = (length + 1) * 9;
            if (length === 0) {
                this.subentry.values[field] = 0;
                width += 9;
            }

            $(`.${this.id}${cssClass} .v-text-field__slot input`).css("width", width);

            if (field === "tariff" && this.subentry.type.id === 2) {
                this.isOwnPrice = false;
            }

            this.priceNumberTariff(3);
            this.sendData();
        },
        handleBlur(field, cssClass) {
            let value = this.subentry.values[field];

            if (value == null || isNaN(value) || value < 0) {
                this.subentry.values[field] = 0;
                value = 0;
            }

            let str = value.toString().replace(",", ".").replace(" ", "");
            str = (Math.round(parseFloat(str) * 100) / 100).toString();

            const index = str.indexOf(".");
            if (index !== -1) {
                str = str.slice(0, index + 3);
            }
            this.subentry.values[field] = parseFloat(str);

            let length = this.subentry.values[field].toString().length;
            let width = (length + 1) * 9;
            if (length === 0) {
                this.subentry.values[field] = 0;
                width += 9;
            }

            $(`.${this.id}${cssClass} .v-text-field__slot input`).css("width", width);

            this.priceNumberTariff(0);
            this.sendData();
        },

        stepper(id, type) {
            if (this.subentry.type.id == 2)
                this.isOwnPrice = false
            if (id == 1) {
                if (type == 1)
                    this.subentry.values.number_of = parseFloat(this.subentry.values.number_of) + 1
                if (type == 0 && this.subentry.values.number_of > 0)
                    this.subentry.values.number_of = parseFloat(this.subentry.values.number_of) - 1
                this.handleBlur('number_of', 'InputPocetSub')
            }
            if (id == 2) {
                if (type == 1)
                    this.subentry.values.tariff = parseFloat(this.subentry.values.tariff) + 1
                if (type == 0 && this.subentry.values.tariff > 0)
                    this.subentry.values.tariff = parseFloat(this.subentry.values.tariff) - 1
                this.handleBlur('tariff', 'InputSadzbaSub')
            }
            if (id == 3) {
                if (type == 1)
                    this.subentry.values.discount += 10
                if (type == 0 && this.subentry.values.discount > 0)
                    if (this.subentry.values.discount <= 10)
                        this.subentry.values.discount = 0;
                    else
                        this.subentry.values.discount -= 10
            }
            if (id == 4) {
                if (type == 1)
                    this.subentry.values.number_of_to = parseFloat(this.subentry.values.number_of_to) + 1
                if (type == 0 && this.subentry.values.number_of_to > 0)
                    this.subentry.values.number_of_to = parseFloat(this.subentry.values.number_of_to) - 1
                this.handleBlur('number_of_to', 'InputPocetSubTo')
            }
            this.priceNumberTariff(0)
        },
        cal_price() {
            if (this.subentry.type.id == 0) {
                this.subentry.unit = "hod"
                this.subentry.price_to = null
                this.subentry.price_to_discount = null

                this.subentry.price_discount = this.autoPrice()
                this.subentry.price = this.subentry.values.auto_price
            }
            if (this.subentry.type.id == 1) {
                this.subentry.unit = ""

                this.subentry.price_discount = this.rangePrice().from
                this.subentry.price = this.subentry.values.price_from
                
                this.subentry.price_to_discount = this.rangePrice().to
                this.subentry.price_to = this.subentry.values.price_to

            }
            if (this.subentry.type.id == 2) {
                this.subentry.price_to = null
                this.subentry.price_to_discount = null

                this.subentry.price_discount = this.ownPrice()
                this.subentry.price = this.subentry.values.own_price
            }
            if (this.subentry.type.id == 4) {
                this.subentry.unit = "hod"
                this.subentry.price_discount = this.rangePrice().from
                this.subentry.price = this.subentry.values.price_from
                this.subentry.price_to_discount = this.rangePrice().to
                this.subentry.price_to = this.subentry.values.price_to
            }
            this.suffix.number_of.suffix = ' ' + this.subentry.unit
            this.suffix.number_of_to.suffix = ' ' + this.subentry.unit
            if (this.subentry.unit != "")
                this.suffix.tariff.suffix = ' ' + this.currentCurrency + ' /' + this.subentry.unit
            else
                this.suffix.tariff.suffix = ' ' + this.currentCurrency

            // if (this.subentry.values.auto_price != this.subentry.values.own_price)
            //     this.isOwnPrice = true

        },
        //poslanie dat parentovi
        sendData() {
            this.cal_price()
            this.$emit('data', this.subentry)
        },
        //ratanie (hodina * sadzba = cena podpoložky) a (vypisanie ceny od - do)
        priceNumberTariff(type) {
            if (this.subentry.values.number_of.toString().includes(',')) {
                this.subentry.values.number_of = (this.subentry.values.number_of).toString().replace(',', '.')
            }
            if (this.subentry.values.tariff.toString().includes(',')) {
                this.subentry.values.tariff = (this.subentry.values.tariff).toString().replace(',', '.')
            }
            if (this.subentry.values.number_of_to.toString().includes(',')) {
                this.subentry.values.number_of_to = (this.subentry.values.number_of_to).toString().replace(',', '.')
            }
            if (this.subentry.type.id == 0) {
                this.subentry.values.auto_price = this.subentry.values.number_of * this.subentry.values.tariff
            }
            if (this.subentry.type.id == 1) {
                this.subentry.values.from_to_price = this.subentry.values.price_from + " - " + this.subentry.values.price_to + " " + this.currentCurrency
            }
            if (this.subentry.type.id == 2) {
                if (!this.isOwnPrice) {
                    this.subentry.values.auto_price = this.subentry.values.number_of * this.subentry.values.tariff_text
                    if (type == 3) {
                        this.subentry.values.own_price = this.subentry.values.number_of * this.subentry.values.tariff
                    }
                }
            }
            if (this.subentry.type.id == 4) {
                this.subentry.values.price_from = this.subentry.values.number_of * this.subentry.values.tariff
                this.subentry.values.price_to = this.subentry.values.number_of_to * this.subentry.values.tariff
                this.subentry.values.from_to_price = this.subentry.values.price_from + " - " + this.subentry.values.price_to + " " + this.currentCurrency
            }
        },
        getEntries: _.debounce(function() {
            if (this.subentry && this.subentry.name && this.subentry.name.length > 1) {
                axios
                .get("/api/offer/entries/"+this.uuidOffer+"/"+this.subentry.name)
                .then((response) => {
                    this.userSubEntries = response.data.subentries;
                    this.ItemsAndPrices = response.data.ItemsAndPrices;
                });
            }
        }, 1000),
    },
    watch: {
        //zmena stavu podpoložky
        //0 - hodinovka
        //1 - od - do
        //2 - vlastna
        //4 - hodiny od - do
        typeCena: function () {
            this.subentry.type = this.types[this.typeCena]
            if (this.typeCena == 0) {
                this.subentry.unit = "hod"
            }
            if (this.typeCena == 2) {
                if (this.subentry.unit == "new")
                    this.subentry.unit = "hod"
                if (this.subentry.unit == "null")
                    this.subentry.unit = ""
            }
            if (this.typeCena == 4) {
                this.subentry.unit = "hod"
            }
            this.priceNumberTariff(0)
        },
        units: function () {
            var uniqueUnits = new Set();
            if (this.units != null) {
                this.units.forEach(unit => {
                    uniqueUnits.add(unit.name);
                });
            }
            this.unitItems.forEach(item => {
                uniqueUnits.add(item);
            });
            this.unitItems = Array.from(uniqueUnits);
        },
        'getTariff': function () {
            if (this.getTariff) {
                this.subentry.values.tariff = this.newTariff
            }
        },
        'subentry.name': function () {
            this.sendData()
            this.getEntries()
        },
        'subentry.text': function () {
            this.sendData()
        },
        'subentry.exclude': function () {
            this.sendData()
        },
        'subentry.unit': function () {
            this.sendData()
        },
        'showText': function () {
            if (!this.showText)
                this.subentry.text = ""
        },
        "subentry.dph": function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.priceNumberTariff(0);
                this.sendData();
            }
        },
        'subentry.values.auto_price': function (newVal, oldVal) {
            if (newVal > 10000000) { // Check if the value is greater than 10M
                this.subentry.values.auto_price = newVal.toString().slice(0, 8); // Set price to first 8 digits
            }
            this.priceNumberTariff(0);
            this.sendData()
        },
        'subentry.values.own_price': function (newVal, oldVal) {
            if (newVal > 10000000) { 
                this.subentry.values.own_price = newVal.toString().slice(0, 8); // Set price to first 8 digits
            }
            this.priceNumberTariff(0);
            this.sendData()
        },
        'subentry.values.price_to': function (newVal, oldVal) {
            if (newVal > 10000000) { // Check if the value is greater than 10M
                this.subentry.values.price_to = newVal.toString().slice(0, 8); // Set price to first 8 digits
            }
            this.priceNumberTariff(0)
            this.sendData()
        },
        'subentry.values.price_from': function (newVal, oldVal) {
            if (newVal > 10000000) { // Check if the value is greater than 10M
                this.subentry.values.price_from = newVal.toString().slice(0, 8); // Set price to first 8 digits
            }
            this.priceNumberTariff(0)
            this.sendData()
        },
        showSimilar: function (newVal, oldVal) {
            if (!newVal) {
                this.ItemsAndPrices = [];
                this.userSubEntries = [];
            }
        }
    },
    computed: {
        SearchSubEntries() {
            this.showSimilar = false
            if (this.subentry && this.subentry.name && this.subentry.name.length > 1) {
                this.showSimilar = true
                return {
                    items: this.ItemsAndPrices,
                    userEntries: this.userSubEntries
                }
            }
            return {
                items: [],
                userEntries: []
            }
        }
    },
    mounted() {
        this.priceNumberTariff(0)
        $('.InputSadzbaSub .v-input__control').click(function () {
            $(".InputSadzbaSub #input-70").focus();
        });
        $('.InputPocetSub .v-input__control').click(function () {
            $(".InputPocetSub #input-70").focus();
        });
        $('.InputPocetSubTo .v-input__control').click(function () {
            $(".InputPocetSubTo #input-70").focus();
        });
        $(".tooltip_hover").hover(
            function () {
                $(this).parent().find('.my_tooltip').css('opacity', '1');
            },
            function () {
                $(this).parent().find('.my_tooltip').css('opacity', '0');
            },
        );
        EventBus.$on('currencyChanged', (val) => {
            this.currentCurrency = val;
            this.updateSuffix();
            this.priceNumberTariff(0);
        });
        if (this.default_dph != "") {
            this.subentry.dph = this.default_dph;
        }
        setTimeout(() => {
            this.handleBlur('number_of', 'InputPocetSub')
            this.handleBlur('number_of_to', 'InputPocetSubTo')
            this.handleBlur('tariff', 'InputSadzbaSub')
        }, 2000);
    },
}
</script>
<style lang="scss">
.add-popis {

    p,
    span,
    strong,
    ul li,
    ol li,
    u {
        font-size: 14px !important;
    }
}

.ql-snow .ql-tooltip a.ql-action::after {
    content: 'Upraviť' !important;
}

.ql-snow .ql-tooltip a.ql-remove::before {
    content: 'Vymazať' !important;
}

.ql-snow .ql-tooltip::before {
    content: "URL:" !important;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "URL:" !important;
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    content: 'Uložiť' !important;
}

.ql-snow .ql-tooltip {
    transform: translate(85px, 10px) !important;
}

.ql-container.ql-snow {
    border: 1px solid #DDE3E8 !important;
    border-top: 0 !important;
}

.ql-toolbar.ql-snow {
    border: 1px solid #DDE3E8 !important;
    margin-top: 1px;
}

.ql-snow .ql-toolbar button,
.ql-snow.ql-toolbar button {
    margin-right: 6px !important;

    svg {
        width: 18px !important;
    }
}
</style>
<style lang="scss" scoped>
.disable_price {
    .icons{
        width: 15px;
        .info{
            .info_icon{
                width: 15px;
                svg{
                    margin: 0;
                }
                &.active{
                    svg{
                        fill: #f3385a;
                    }
                }
            }
        }
    }
}
.price-for-hours {
    @media (max-width: 1200px) {
        width: 120px;
    }
}

.price-for-hours {
    @media (max-width: 1200px) {
        width: 50%;
    }

    &:first-child {
        input {
            border-right: 0;
        }
    }

    input {
        border: 1px solid #DDE3E8;
    }
}

.cena_zero {
    width: 230px;

    @media (max-width: 1200px) {
        width: 100% !important;
    }
}

.cena_one {
    width: 205px;

    @media (max-width: 1200px) {
        width: 100% !important;
    }
}

.cena_two {
    width: 145px;

    @media (max-width: 1200px) {
        width: 100% !important;
    }

}

.entry_tooltip {
    width: auto !important;
    min-width: 180px;
    bottom: 10px !important;
    right: -6px !important;
    display: flex;
    flex-direction: column;
    gap: 5px;
    .line{
        width: 70%;
        height: 1px;
        background-color: #fff;
        opacity: 0.5;
        margin: 0 auto;
    }
    span{
        font-weight: bold;
    }
}
.similar_entries {
    z-index: 10000;
    position: absolute;
    left: 0;
    top: 56px;
    height: auto;
    max-height: 340px;
    min-width: 504px;
    box-shadow: 0px 2px 8px rgb(0 0 0 / 10%);
    border: 1px solid #dde3e8;
    background: #fff;
    overflow: auto;
    width: 100%;

    .database-items {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 5px 14px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 16px;
        background: #383C4C;
        color: #fff;
        text-transform: uppercase;
    }

    .entry {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        height: 50%;
        padding: 14px;
        background: #fff;
        cursor: pointer;
        border-bottom: 1px solid #dde3e8;

        &:hover {
            background: #F7F8F8;
        }

        .left {
            display: flex;
            flex-direction: column;
            gap: 3px;
            flex: 4;

            h6.name {
                font-family: Roboto;
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }

            span.description {
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
                line-height: 16px;
                color: #212541;
                opacity: 0.5;
            }
        }

        .right {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            span {
                font-family: Roboto;
                font-style: normal;
                font-weight: 300;
                font-size: 14px;
                line-height: 16px;
                color: #212541;
            }
        }
    }
}

.offer-top {
    @media (max-width: 1200px) {
        margin-top: 5rem;
    }

    .subentry_handle {
        @media (max-width: 1200px) {
            width: 15px;
            height: 15px;
            margin-left: 0 !important;
            margin-bottom: 15px;
        }
    }

    .IndexPocetSub {
        width: 150px;
    }

    .info {
        position: relative;
        margin-left: 8px;

        .info_icon {
            pointer-events: all;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            float: right;

            img {
                width: 80%;
                height: 80%;
            }
        }

        .my_tooltip {
            pointer-events: none;
            opacity: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 300px;
            background: #F3385A;
            box-sizing: border-box;
            box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 18px;
            text-align: center;
            color: #fff;
            padding: 10px;
            position: absolute;
            bottom: 8px;
            right: -5px;
            z-index: 10000;
            transition: opacity .5s ease-in-out;

            &::after {
                content: '';
                width: 15px;
                height: 15px;
                background: #F3385A;
                position: absolute;
                right: 8px;
                margin: auto;
                bottom: -3px;
                transform: rotate(45deg);
                border-radius: 3px;
            }
        }
    }

    font-family: Roboto;

    .popisNone {
        width: 140px;
        margin-left: 17px;
        padding-top: 8px;
        margin-top: 9px;
        display: flex;
        cursor: pointer;
        font-family: Roboto;
        font-style: italic;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        color: #212541;
    }

    .info {
        cursor: pointer;

        path {
            stroke: #CED0D5;
        }

        &:hover>path {
            stroke: #383C4C;
        }
    }

    .trash {
        cursor: pointer;

        path {
            stroke: #9598A7;
        }

        &:hover>path {
            stroke: #383C4C;
        }
    }

    .sum input {
        text-align: right;
    }

    padding: 20px 35px 20px 20px;
    display: flex;

    svg {


        margin: {
            top: 22px;
            right: 10px;
        }
    }

    .textarea-icons {
        position: absolute;
        right: 9px;
        top: 12px;
    }


    .inputs {
        @media (max-width: 1200px) {
            display: flex;
            flex-direction: column;
            width: 100%;
        }

        @media (max-width: 600px) {
            margin: 0 !important;
            margin-top: 20px !important;
            width: 100% !important;
        }

        display: block;

        .top-inputs {
            display: flex;
            align-items: center;
            position: relative;

            @media (max-width: 1200px) {
                flex-direction: column;
            }

            @media (max-width: 600px) {
                width: 100% !important;
            }

            .add-popis-mobile {
                display: none;

                @media (max-width: 1200px) {
                    display: block;
                }

                @media (max-width: 600px) {
                    width: 100% !important;
                }

                //border: 1px solid #DDE3E8;
                textarea {
                    padding-top: 4px !important;
                    border: 0 !important;
                    border-top: 28px solid transparent !important;
                    border-radius: 0 !important;

                    @media (max-width: 1200px) {
                        height: 150px;
                    }
                }

                svg {
                    position: absolute;
                    top: 3px;
                    right: -14px;
                    width: 17px;

                    @media (max-width: 1200px) {
                        position: absolute;
                        top: 6px;
                        right: -6px;
                        width: 20px;
                        left: auto;
                    }
                }
            }
            .dph_input{
                flex: 2;
            }
            .inline-subentries {
                display: flex;

                @media (max-width: 1200px) {
                    width: 100%;
                }

                @media (max-width: 600px) {
                    flex-direction: column;
                    width: 100% !important;
                }

                .IndexPocetSub {
                    @media (max-width: 1200px) {
                        width: 50%;
                        border-left: 1px solid #DDE3E8;
                    }

                    @media (max-width: 600px) {
                        width: 100% !important;
                    }
                }

                .InputSadzbaSub,
                .InputPocetSub {
                    @media (max-width: 1200px) {
                        width: 50%;
                    }

                    @media (max-width: 600px) {
                        width: 100% !important;
                    }
                }
            }
        }

        .name {
            width: 100%;
        }

        .unit {
            width: 150px;
        }

        .select {
            width: 210px;
        }

        .price {
            width: 100px;

            @media (max-width: 1200px) {
                display: none;
            }
        }

        .subentry-price-mobile {
            display: none;

            @media (max-width: 1200px) {
                display: flex;
            }

            .price {
                @media (max-width: 1200px) {
                    width: 50%;
                    display: block;

                    &:first-child {
                        input {

                            border-left: 1px solid #DDE3E8 !important;
                        }

                    }
                }
            }
        }

        .form-floating.txtarea {
            height: auto;
        }

        .form-floating {
            height: 56px;

            .stepper {
                position: absolute;
                right: 0;
                top: 0;
                display: grid;
                height: 100%;
                width: 32px;

                span {
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    &:first-child {
                        border-bottom: 1px solid #ECF0F3;
                    }
                }
            }

            input::-webkit-calendar-picker-indicator {
                opacity: 1;
                font-size: 10px;
                position: absolute;
                right: 10px;
                top: 20px;
            }

            select {
                font: {
                    style: normal;
                    weight: normal;
                    size: 14px;
                }

                line-height: 16px;
                color: #212541;
                background-color: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                border-radius: 0;
                border-left:0;

                &:focus {
                    box-shadow: none;
                }
            }

            .form-select {
                background-image: url("/img/create_offer/select-arrow.svg");
                background-size: 9px 9px;
            }

            input {
                font: {
                    style: normal;
                    weight: normal;
                    size: 14px;
                }

                line-height: 16px;
                color: #212541;
                background: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                border-radius: 0;
                border-left:0;

                &:focus {
                    box-shadow: none;
                }
            }

            label {
                padding: 20px 0.75rem;

                font: {
                    style: normal;
                    weight: bold;
                    size: 14px;
                }

                text-transform: uppercase;
                line-height: 16px;
                color: #212541;
            }
        }
    }

    .add-popis {
        display: block;

        @media (max-width: 1200px) {
            display: none;
        }

        .form-floating {

            //border: 1px solid #DDE3E8;
            textarea {
                padding-top: 4px !important;
                border: 0 !important;
                border-top: 28px solid transparent !important;
                height: 80px;

                font: {
                    style: normal;
                    weight: 500;
                    size: 14px;
                }

                line-height: 16px;
                color: #212541;
                background: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                border-radius: 0;

                &:focus {
                    box-shadow: none;
                }
            }
        }
    }

    .summary {
        @media (max-width: 1200px) {
            width: 100%;
        }

        width: auto;
        margin-left: auto;

        .icons {
            margin-left: 15px;

            @media (max-width: 1200px) {
                display: flex;
                justify-content: flex-end;
                margin-top: 10px;
            }

            svg {
                margin-right: 0;
            }
        }

        .summary-top {
            @media (max-width: 1200px) {
                display: block;
            }

            display: flex;
            align-items:center;

            .sum.form-floating {
                @media (max-width: 1200px) {
                    width: 100%;
                }

                width: 235px;
                margin-left: auto;

                input {
                    font: {
                        style: normal;
                        weight: bold;
                        size: 14px;
                    }

                    line-height: 16px;
                    color: #212541;
                    background: #FFFFFF;
                    border: 1px solid #DDE3E8;
                    box-sizing: border-box;
                    border-radius: 0;

                    &:focus {
                        box-shadow: none;
                    }
                }

                label {
                    padding: 20px 0.75rem;
                    padding-right: 0;

                    font: {
                        style: normal;
                        weight: bold;
                        size: 14px;
                    }

                    text-transform: uppercase;
                    line-height: 16px;
                    color: #212541;
                }

                &>label {
                    right: 0;
                    left: unset;
                }
            }
        }

        .summary-bottom {
            display: flex;
            margin-top: 10px;

            @media (max-width: 1200px) {
                justify-content: flex-end;
            }

            .icons {
                @media (max-width: 1200px) {
                    margin-right: 0 !important;
                    margin-top: 0 !important;
                }

                display: -webkit-box;
                display: flex;
                -webkit-box-pack: end;


            }

            .block {
                font: {
                    style: normal;
                    weight: normal;
                    size: 14px;

                }

                line-height: 16px;
                color: #212541;
                margin-bottom:0;
            }

            input[type="checkbox"] {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                -webkit-tap-highlight-color: transparent;
                cursor: pointer;
                margin: 0px 0px 0 10px;
                background: #C7D4EB;
                border-radius: 25px;
            }

            .toggle label {
                @media (max-width: 600px) {
                    width: 70%;
                }
            }

            .toggle {
                height: 22px;
                width: 40px;
                display: inline-block;
                position: relative;
                margin: 0;
                border: none;
                background: #FFFFFF;
                border-radius: 3px;
                transition: all 0.2s ease;

                &:focus {
                    outline: 0;
                }

                &:after {
                    content: "";
                    position: absolute;
                    top: 4px;
                    left: 3px;
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    background: white;
                    box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
                    transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
                }

                &:checked {
                    border-color: #2ED8B6;
                    background: #2ED8B6;
                }

                &:checked:after {
                    transform: translatex(20px);

                }
            }
        }
    }
}

.sum>.form-control:focus~label,
.sum>.form-control:not(:placeholder-shown)~label,
.sum>.form-select~label {
    transform: translateY(-14px) translateX(-7px);
    font-size: 12px !important;
}
</style>
<style lang="scss">
.InputSadzbaSub,
.InputPocetSub {
    min-width: 110px;

    .v-text-field__slot {
        &:hover {
            background: #FFF !important;

        }

        @media (max-width: 1200px) {
            border-left: 0px !important;
        }

        height:58px;
        margin-bottom:0 !important;
        border-left: 1px solid #DDE3E8 !important;
        border-top: 1px solid #DDE3E8 !important;
        border-bottom: 1px solid #DDE3E8 !important;
        border-right: 1px solid #DDE3E8 !important;
        border-radius:0 !important;
        padding: .5rem .75rem;

        input {
            width: 30px;
            min-width: 50px;
            padding-left: 3px;
            padding-top: 0;
            padding-bottom: 0;
            margin-top: 20px;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541 !important;
            flex: initial !important;
        }

    }

    .v-text-field__suffix {
        pointer-events: none !important;
        width: 85px !important;
        margin-top: 20px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
    }

    .v-label.v-label--active.theme--light {
        left: 6px !important;
        top: 26px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 16px !important;
        text-transform: uppercase !important;
        line-height: 16px !important;
        color: #212541 !important;
        opacity: .65 !important;
        margin-bottom: 0;
        -webkit-transform: translateY(-18px) scale(.75);
        transform: translateY(-18px) scale(.75);
    }

    .v-input .v-label {
        left: 6px !important;
        top: 26px !important;
        font-family: Roboto !important;
        font-style: normal !important;
        font-weight: bold !important;
        font-size: 16px !important;
        text-transform: uppercase !important;
        line-height: 16px !important;
        color: #212541 !important;
        opacity: .65 !important;
        margin-bottom: 0;
        -webkit-transform: translateY(-18px) scale(.75);
        transform: translateY(-18px) scale(.75);
    }

    .v-text-field>.v-input__control>.v-input__slot {
        &:after {
            content: none !important;
        }

        &:before {
            content: none !important;
        }
    }

    .v-input {
        height: 56px;
        margin-top: 0 !important;
        padding-top: 0 !important;
    }
}

/** new codes */
.subentry-box {
    background: #fff;
    border-left: 1px solid #DDE3E8;
    border-bottom: 1px solid #DDE3E8;
    border-bottom-left-radius: 4px;
    border-right: 1px solid #DDE3E8;
    border-bottom-right-radius: 4px;
    flex: 1;
}

.summary-last {
    position: relative;
    display: flex;
    align-items: center;

    .sum.form-floating {
        width: 235px;
        margin-left: auto;

        @media (max-width: 1200px) {
            width: 100%;
        }

        input {
            font: {
                style: normal;
                weight: bold;
                size: 14px;
            }

            line-height: 16px;
            color: #212541;
            background: #FFFFFF;
            border-bottom: 2px solid #989898 !important;
            box-sizing: border-box;
            border-radius: 0;

            &:focus {
                box-shadow: none;
            }
        }

        label {
            padding: 20px 0.75rem;
            padding-right: 0;

            font: {
                style: normal;
                weight: bold;
                size: 14px;
            }

            text-transform: uppercase;
            line-height: 16px;
            color: #212541;
        }

        &>label {
            right: 0;
            left: unset;
        }
    }
}

.subentry_right {
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.offer-top .inputs .top-inputs>.inline-subentries {
    flex: 10;
}

.offer-top .inputs .top-inputs>.inline-subentries>* {
    flex: 1 1 auto;
}

.offer-top .inputs .form-floating {
    flex: 0 1 auto;
    width: auto;
}

.subentry .popeditor-trigger-holder .popisNone {
    padding-left: 30px;
}

.offer-top .inputs .form-floating.price {
    width: auto !important;
    flex: 0 0 auto;
}
</style>
